import { useEffect, useState } from "react";
import { selectEntitiesByFilters } from "../../../../shared/store/views/entityView";
import { ShortcutsFilter } from "../../../../shared/utils/entitiesFiltersUtils";
import { useSelector } from "react-redux";
import { getKey } from "../../../../shared/utils/tabsUtils";
import { usePermission } from "../../../../shared/hooks/usePermission";
import Shourtcut from "../../../../shared/components/features/shourtcut/Shourtcut";
import Widget from "../../../../shared/components/features/widget/Widget";
import iconsList from "../../../../shared/components/ui/icons/iconsList";
import classes from "./ShortcutWidget.module.css";

const ShortcutWidget = () => {

    const { texts } = useSelector(state => state.translate);
    const shortcuts = useSelector((state) => selectEntitiesByFilters(state, ShortcutsFilter));
    const [filteredShortcuts, setFilteredShortcuts] = useState([]);
    const hasPermission = usePermission();

    useEffect(() => {
        const allowed = shortcuts?.filter(s => !s?.conditionType || hasPermission(getKey(s?.key)));
        setFilteredShortcuts(allowed);
    }, [shortcuts]);

    return (
        <Widget
            color="#F6F6F6"
            title={texts.Shortcuts}
            titleColor="black"
            icon={iconsList.shortcuts}
            className={classes.ShortcutWidget}
        >
            <div className={classes.ToolsList}>
                {filteredShortcuts?.length > 0 ?
                    filteredShortcuts?.map((s, index) =>
                        <Shourtcut key={index} shourtcut={s} />
                    )
                    :
                    <div className={classes.NoTools}>
                        {texts.noUsefulTools}
                    </div>
                }
            </div>
        </Widget>
    );
};

export default ShortcutWidget;
